const STAR_PATH =
  "M10.4538 0.392665C10.854 -0.130886 11.6424 -0.130886 12.0427 0.392665L13.3488 2.10121C13.6138 2.44783 14.0729 2.58264 14.4832 2.43431L16.5058 1.70315C17.1255 1.47909 17.7888 1.90534 17.8424 2.56216L18.0175 4.70564C18.053 5.1405 18.3664 5.50213 18.7918 5.59918L20.8885 6.07754C21.531 6.22412 21.8585 6.94127 21.5486 7.52284L20.537 9.42071C20.3318 9.80574 20.3999 10.2794 20.7053 10.591L22.2105 12.127C22.6718 12.5977 22.5596 13.3781 21.9844 13.6997L20.1074 14.7494C19.7266 14.9624 19.5278 15.3976 19.6162 15.8249L20.0521 17.9309C20.1857 18.5762 19.6694 19.172 19.0116 19.1317L16.865 18.9999C16.4295 18.9732 16.027 19.2319 15.8704 19.6391L15.0985 21.6465C14.862 22.2616 14.1055 22.4837 13.574 22.0941L11.8394 20.8228C11.4875 20.5648 11.009 20.5648 10.6571 20.8228L8.92248 22.0941C8.39095 22.4837 7.63448 22.2616 7.39795 21.6465L6.62606 19.6391C6.46947 19.2319 6.06692 18.9732 5.63144 18.9999L3.48486 19.1317C2.82708 19.172 2.31079 18.5762 2.44436 17.9309L2.88024 15.8249C2.96867 15.3976 2.7699 14.9624 2.38909 14.7494L0.512052 13.6997C-0.0631306 13.3781 -0.175332 12.5977 0.285929 12.127L1.7912 10.591C2.09658 10.2794 2.16468 9.80574 1.95946 9.42071L0.947908 7.52284C0.637937 6.94127 0.96545 6.22412 1.60796 6.07754L3.7047 5.59918C4.13007 5.50213 4.44343 5.1405 4.47895 4.70564L4.65404 2.56216C4.7077 1.90534 5.37094 1.47909 5.9907 1.70315L8.01321 2.43431C8.42353 2.58264 8.88265 2.44783 9.14764 2.10121L10.4538 0.392665Z";

export default function StatusBadge({ isActive = true, size = 22, title }) {
  const color = isActive ? "#1EBD73" : "#EF4444";

  return (
    <svg width={size} height={size} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title ? <title>{title}</title> : null}
      <path d={STAR_PATH} fill={color} />
      {isActive ? (
        <path
          d="M7.5 12l3.5 3.5 5-5.5"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M8.5 8.5l6 6M14.5 8.5l-6 6"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}
